import { Component, OnInit } from '@angular/core'

@Component({
    selector: './slot-status-page',
    templateUrl: './slot-status-page.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class SlotStatusPageComponent implements OnInit {

    ngOnInit() {

    }
}